import { createSlice, useSelector } from '@reduxjs/toolkit';
import { RootState } from '.';
import { AssetForm } from '../forms';

export type OuAdminEditorState = {
  assetForm: AssetForm;
  hasErrors: false;
};

export const initialState: OuAdminEditorState = {
  assetForm: new AssetForm(),
  hasErrors: false,
};

const assetEditorSlice = createSlice({
  name: 'assetEditor',
  initialState,
  reducers: {
    UpdateAssetForm: (state, action: any) => {
      state.assetForm = action.payload;
    },
    CreatAssetForm: (state, action: any) => {
      state.assetForm = action.payload;
    },
  },
  extraReducers: {},
});

export const { UpdateAssetForm, CreatAssetForm } = assetEditorSlice.actions;

// export assetEditorSlice selector to get the slice in any component
export const assetEditorSelector = (state: RootState) => state.assetEditor;
// export The reducer
const assetEditorReducer = assetEditorSlice.reducer;
export default assetEditorReducer;
